import React from 'react';
import { Modal } from './Modal';
import { X } from 'lucide-react';

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DownloadModal: React.FC<DownloadModalProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fixed inset-0  z-50" />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-51 w-full px-4 max-w-[480px]">
        <div className="bg-alpha-background-secondary rounded-xl border border-white/10 relative w-full max-w-[480px]">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-[#e7e7e7] bg-transparent border-none rounded-md hover:bg-white/10 transition-colors"
          >
            <X size={16} />
          </button>

          <div className="p-6">
            <h2 className="text-base font-semibold text-[#e7e7e7] m-0 pr-6">Download as ZIP</h2>

            <div className="h-px bg-[#414142] my-3 -mx-6" />

            <div className="space-y-4">
              <p className="text-[#e7e7e7]/70 text-sm m-0">
                Are you sure you want to download the project as a ZIP file?
              </p>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                  }}
                  className="px-4 py-2.5 text-[#e7e7e7] bg-transparent border border-white/10 rounded-lg hover:bg-white/10 transition-colors text-sm font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onConfirm();
                  }}
                  className="px-6 py-2.5 bg-gradient-to-b from-alpha-primary-start to-alpha-primary-end rounded-lg text-white text-sm font-medium hover:brightness-94 transition-all"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
